<template>
  <div class="home">
    <main>
      <Header />

      <Banner />
      <Main>
        <template #aside>
          <Aside fetch="materials/catalogs" />
        </template>
        <template #cards>
          <Cards>
            <template #card>
              <Loader v-if="loading" />

              <EmptyPlace wrapper="posts" v-else-if="!cards.length">
                <div class="Empty__content">
                  <p>{{ $t("NO_DATA_HERE") }}</p>
                  <div class="Empty__image">
                    <img
                      src="@/assets/images/2tu3pma5HRsX4f41PeBqCa.svg"
                      alt="Ничего не найдено"
                    />
                  </div>
                </div>
              </EmptyPlace>

              <div class="main__cards" v-else>
                <PostHelp v-for="card in cards" :key="card.id" :card="card" />
              </div>
            </template>
            <template #pagination>
              <Pagination
                v-if="totalCount > perPage"
                :current="+currentPage"
                :total="+totalCount"
                :perPage="+perPage"
                :range="1"
              />
            </template>
          </Cards>
        </template>
      </Main>
    </main>
    <Footer />

    <Languages :locales="$route.meta.langs" />
  </div>
</template>

<script>
import { Banner, Main } from "@/components";
import { SecondHeader as Header } from "@/components/app/Headers";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Home",
  metaInfo: {
    title: "Центр взаимопомощи",
    titleTemplate: "%s | Helpcenter",
    meta: [
      {
        name: "description",
        content:
          "Некоммерческий проект для людей, которые могут помочь или кому необходима помощь в этот непростой период. Мы не размещаем рекламу, платные услуги, лживые обращения и прочие объявления, которые не соответствуют общественным нормам морали. Если вам необходима материальная помощь, у вас нет продуктов, нужно что-то привезти, вас выселяют с квартиры или вы можете помочь это решить, оставляйте заявку в правом верхнем углу сайта. | Центр взаимопомощи"
      },
      {
        name: "keywords",
        content:
          "Некоммерческий проект, Helpcenter.life, Helpcenter.kz, Helpcenter.ru, Helpcenter.uz, центр взаимопомощи"
      },
      {
        name: "author",
        content: "Helpcenter.life | Sailet"
      },
      {
        name: "geo",
        content: "Kazakhstan"
      },
      {
        name: "cmsmagazine",
        content: "b7e51a05de514284dda10a90ba190f5c"
      },
      {
        property: "og:locale",
        content: "ru_RU"
      },
      {
        property: "og:type",
        content: "website"
      },
      {
        property: "og:description",
        content:
          "Некоммерческий проект для людей, которые могут помочь или кому необходима помощь в этот непростой период. Мы не размещаем рекламу, платные услуги, лживые обращения и прочие объявления, которые не соответствуют общественным нормам морали. Если вам необходима материальная помощь, у вас нет продуктов, нужно что-то привезти, вас выселяют с квартиры или вы можете помочь это решить, оставляйте заявку в правом верхнем углу сайта. | Центр взаимопомощи"
      },
      {
        property: "og:image",
        content: "../assets/images/12AzhkUkBYZ-p4x8Ku1aPi.svg"
      },
      {
        property: "og:url",
        content: `${document.location.href}`
      }
    ]
  },
  data: () => ({
    loading: true
  }),
  computed: {
    ...mapGetters([
      "cards",
      "totalCount",
      "currentPage",
      "perPage",
      "hints",
      "share"
    ]),
    websiteName() {
      return this.$route.meta.description.websiteName;
    }
  },
  methods: mapActions(["fetchCards", "fetchFiltersList", "fetchChartData"]),
  mounted() {
    this.fetchCards({
      API: this.$route.meta.API,
      page: this.currentPage || this.$route.query.page
    }).then(() => (this.loading = false));
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const lang = vm.$route.meta.langs[0].locale,
        path = vm.$route.path.slice(0, 4);
      localStorage.setItem("curLang", lang.toUpperCase());

      new Promise(resolve => resolve()).then(() => {
        vm.fetchChartData(`${path}/${lang}`);
      });
    });
  },
  components: {
    Header,
    Banner,
    Main,
    Aside: () => import("@/components/Aside"),
    Cards: () => import("@/components/Cards"),
    PostHelp: () => import("@/components/app/Posts/PostHelp"),
    Pagination: () => import("@/components/app/Pagination"),
    EmptyPlace: () => import("@/components/app/EmptyPlace"),
    Languages: () => import("@/components/app/Languages")
  }
};
</script>
